import React, {useCallback, useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import {BottomNavigationBarContainerBox} from "./boxes/container/bottom-navigation-bar-container.box";
import {BottomNavigationBarMenuItemsListComponent} from "./bottom-navigation-bar-menu-items-list.component";
import {CyClass} from "../../../common/cy-classes";
import classNames from 'classnames';
import {HYBRID_EMBEDDED_NAV_MENU} from "./bottom-navigation-bar-consts";
import {BottomNavigationBarMenuItemsContainerBox} from "./boxes/container/bottom-navbar-menu-item-container.box";
import {useServices} from '../../react-hooks/use-services.hook';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";
import {FlexFixedSizeItemBox} from '../../themes/architecture/css-helpers/flex';

interface BottomNavigationBarComponentProps extends ComponentServicesPick<'bottomNavigationBar'> {
    isInVideoSlidesArena?: boolean;
}

const ComponentBody: React.FC<BottomNavigationBarComponentProps> = observer((props) => {
    const services = useServices();
    const spacerBoxRef = useRef<HTMLDivElement | null>(null);

    if (!props.bottomNavigationBar.isBottomNavigationEnabled && !Boolean(props.isInVideoSlidesArena)) {
        return null;
    }

    const captureBottomNavbarBox = useCallback((r: HTMLDivElement | null) => {
        props.bottomNavigationBar.setBottomNavBarRef(r);
    }, [props.bottomNavigationBar]);

    // instead of using "bottomNavbarHeight" directly in render (return statement) so the component will respond to observable changes
    // i do this useEffect to avoid unnecessary rerenders and maybe recreation of elements ref.
    useEffect(() => {
        const spacerHeight = props.bottomNavigationBar.bottomNavbarHeight + 'px';
        if (spacerBoxRef.current) {
            spacerBoxRef.current.style.height = spacerHeight;
        }
    }, [props.bottomNavigationBar.bottomNavbarHeight]);

    return (
        <>
            <FlexFixedSizeItemBox ref={spacerBoxRef} style={{marginBottom: "env(safe-area-inset-bottom)", height: "5rem"}} />
            <BottomNavigationBarContainerBox
                shouldElevate={services.spinner.isSpinning}
                ref={captureBottomNavbarBox}
                className={classNames(HYBRID_EMBEDDED_NAV_MENU, CyClass('cy-hybrid-embedded-nav-menu'))}
            >
                <BottomNavigationBarMenuItemsContainerBox>
                    <BottomNavigationBarMenuItemsListComponent />
                </BottomNavigationBarMenuItemsContainerBox>
            </BottomNavigationBarContainerBox>
        </>
    );
});

export const BottomNavigationBarComponent = withServices(ComponentBody, ['bottomNavigationBar']);